import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface formDataProps {
	formData: any;
}

const OutCentreDetailTop = (props: formDataProps) => {
	const { formData } = props;
	const { t } = useTranslation();
	return (
		<Grid container alignItems='center' sx={{ height: '100%' }}>
			<Grid item xs={2}>
				<Typography variant='body2' color='#5D5E61'>
					{t('common.toCentre')}
				</Typography>
			</Grid>
			<Grid item xs={4}>
				<Typography variant='body2'>{formData?.toCentre || '-'}</Typography>
			</Grid>
			<Grid item xs={2}>
				<Typography variant='body2' color='#5D5E61'>
					{t('common.toDistrict')}
				</Typography>
			</Grid>
			<Grid item xs={4}>
				<Typography variant='body2'>{formData?.toDistrict || '-'}</Typography>
			</Grid>
			<Grid item xs={2}>
				<Typography variant='body2' color='#5D5E61'>
					{t('common.applyTime')}
				</Typography>
			</Grid>
			<Grid item xs={4}>
				<Typography variant='body2'>{formData?.applyDate || '-'}</Typography>
			</Grid>
			<Grid item xs={2}>
				<Typography variant='body2' color='#5D5E61'>
					{t('common.outCentreTime')}
				</Typography>
			</Grid>
			<Grid item xs={4}>
				<Typography variant='body2'>
					{formData?.quitCentreDate || '-'}
				</Typography>
			</Grid>
		</Grid>
	);
};

export default OutCentreDetailTop;
